<template>
  <div class="" >
    <b-modal ref="my-modal" size="xl" hide-footer title="">
      <div class="d-block text-center">
          <h3>說明文字</h3>
      </div>

      <div class="form-group row">
        <div class="col-sm-10">
          <MyCkEditor v-model="htmlContent" height="600px" width="800px"></MyCkEditor>
        </div>
      </div>
      <b-button class="mt-2" variant="btn btn-primary" block @click="toggleModal()">儲存</b-button>
      <b-button class="mt-3" variant="btn btn-danger" block @click="hideModal">關閉</b-button>
    </b-modal>


  </div>

</template>

<script>


//<DLGEditor ref="dlgEditor" v-on:returnOk="dlgEditorReturnOK" />
//
//
// editHtmlContent(param,item,htmlContent){
//   this.$refs.dlgEditor.param=param;
//   this.$refs.dlgEditor.callbackItem=item;
//   this.$refs.dlgEditor.htmlContent=htmlContent;
//   this.$refs.dlgEditor.showModal();
// },
// dlgEditorReturnOK(param,item){
//   item.HelpContent.Content=this.$refs.dlgEditor.htmlContent;
// }
import MyCkEditor from "@/taylorCommon/component/MyCkEditor.vue";

export default {
  components: {MyCkEditor},
  props:["param","callbackItem","htmlContent"],
  data: function() {
    return {
      showThis:false,
    };
  },
  methods: {
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    toggleModal() {
      this.$refs['my-modal'].toggle('#toggle-btn')

      this.$emit('returnOk',this.param,this.callbackItem);
    },
    async loadData(){
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>
